module.exports = __webpack_public_path__ + "static/media/user-tag-brown.bb26f0a1.svg";